import { createSlice } from "@reduxjs/toolkit";
const quoteSlice = createSlice({
  name: "booking",
  initialState: {
    baseCurrency: "THB",
    forexCurrencyTicker: "THB",
    forexCurrencyRate: 1,
    rates: null,
    airportPickUp: false,
    airportDropOff: false,
    extraBed: false,
    wellnessPackageCost: 0,
    totalDiscount: 0,
    returningDiscount: 0,
    transferCost: 0,
    grandTotal: 0,
    quoteAccepted: false,
    accomPref: "noPref",
    promotionName: "",
  },
  reducers: {
    setAccomPref(state, action) {
      const selection = action.payload;
      state.accomPref = selection.preference;
    },
    setAccomPrefToggle(state, action) {
      switch (state.accomPref) {
        case "ground":
          state.accomPref = "noPref";
          break;
        case "first":
          state.accomPref = "ground";
          break;
        case "noPref":
          state.accomPref = "first";
          break;
        default:
          state.accomPref = "noPref";
      }
    },
    setQuotationPrices(state, action) {
      const quote = action.payload;
      state.wellnessPackageCost = Math.round(quote.wellnessPackageCost);
      state.totalDiscount = Math.round(quote.totalDiscount);
      state.returningDiscount = Math.round(quote.returningDiscount);
      state.transferCost = Math.round(quote.transferCost);
      state.grandTotal = Math.round(quote.grandTotal);
      state.promotionName = quote.promotionName;
    },
    setForexTicker(state, action) {
      const forex = action.payload;
      state.forexCurrencyTicker = forex.forexCurrencyTicker;
      state.forexCurrencyRate = forex.forexCurrencyRate;
    },
    setRates(state, action) {
      const forex = action.payload;
      state.rates = forex.rates;
    },
    setAirportPickUpToggle(state) {
      state.airportPickUp = !state.airportPickUp;
    },
    setAirportDropOffToggle(state) {
      state.airportDropOff = !state.airportDropOff;
    },
    setExtraBedToggle(state) {
      state.extraBed = !state.extraBed;
    },
    setExtraBedDisable(state) {
      state.extraBed = false;
    },
    setQuoteAcceptedToggle(state) {
      state.quoteAccepted = !state.quoteAccepted;
    },
  },
});

export const quoteActions = quoteSlice.actions;

export default quoteSlice;
